var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-panel',_vm._l(((_vm.news || {}).items || []),function(item,i){return _c('news-item',{key:i,attrs:{"news":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }